// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8345023d","453":"2c5fc732","455":"36278f82","977":"ee6b615f"}[chunkId] + ".chunk.js";
};